import styled, { css, keyframes } from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import { Form as FormComponent } from '@prisjakt/ui-review-form';
import { Link as LinkComponent } from 'react-router-dom';
import ModalComponent from '../../../../components/modal';

type ContentProps = {
  height: string;
};

const desktopAnimation = keyframes`
  from {
    transform: translateY(100%);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const mobileAnimation = keyframes`
 from {
    transform: translateY(100%);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const Content = styled.div<ContentProps>(
  p => css`
    display: flex;
    flex-direction: row;
    max-height: calc(0.95 * ${p.height});
    margin: 0 auto;
    overflow: auto;

    ${media.mediumDown`
      max-height: ${p.height};
      width: 100%;
    `};

    a {
      color: ${p.theme.text.callToAction};

      &:hover {
        color: ${p.theme.text.callToActionHover};
      }
    }

    ${media.mediumDown`
      padding: 0;
    `};
  `
);

const modalReset = css`
  position: fixed;
  bottom: 0;
  height: 95%;
  margin: 0 auto;
  padding: 0;
  transform: translateY(0);
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;

  ${media.mediumDown`
    top: ${layout.headerHeight.mobile.rem};
    height: calc(100% - ${layout.headerHeight.mobile.rem});
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    max-width: 100%;
    transform: translate(0, 0);
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  `};
`;

export const Modal = styled(ModalComponent)`
  && {
    ${modalReset}
    animation: ${desktopAnimation} 300ms cubic-bezier(0.1, 0.74, 0.29, 1) 1;

    ${media.mediumDown`
      animation: ${mobileAnimation} 300ms cubic-bezier(0.1, 0.74, 0.29, 1) 1;
    `};
  }
`;

export const PageTitle = styled.h2`
  margin-bottom: ${layout.spacing.small};
`;

export const Form = styled(FormComponent)`
  padding: ${layout.measurements.spacingLarge};
  padding-bottom: 0;
  flex-shrink: 0;

  ${media.mediumDown`
    width: 100%;
    padding: ${layout.spacing.small};
    padding-bottom: 0;
  `};
`;

type FormWrapperProps = {
  height: string;
};

export const FormWrapper = styled.div<FormWrapperProps>(
  p => css`
    width: 100%;
    max-width: 680px;
    margin: 0 auto;

    ${media.mediumDown`
    width: 100%;
    height: calc(${p.height} - ${layout.headerHeight.mobile.rem})
  `};
  `
);

export const StoreCard = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background: ${p => p.theme.bg.secondary};
  border-radius: 5px;
  padding: ${layout.spacing.xSmall};
  margin-bottom: ${layout.spacing.small};
  max-width: 600px;
`;

export const StoreInfo = styled.div`
  margin-left: ${layout.spacing.xSmall};
  font-size: ${layout.measurements.fontSizeSmall};
`;

export const Policy = styled.div`
  margin-bottom: ${layout.spacing.medium};
  font-size: ${layout.measurements.fontSizeSmall};
`;

export const Optional = styled.span`
  color: ${p => p.theme.text.quaternary};
  font-weight: normal;
  margin-left: ${layout.spacing.xSmall};
`;

export const Link = styled(LinkComponent)`
  color: ${p => p.theme.text.callToAction};

  &:hover {
    color: ${p => p.theme.text.callToActionHover};
  }
`;

export const PurchaseDateInput = styled.input`
  width: 100%;
  background: ${p => p.theme.inputs.primary.bg};
  padding: 10px;
  border: 1px solid ${p => p.theme.inputs.primary.border};
  outline: 0;
`;
